<template>
    <div class="page">
        <public-head title="开设院校"></public-head>
         <div class="school-list" v-if="schoolLists.length>0">
        <div v-for="(item,index) in schoolLists" :key="index">
            <div class="school-item" @click="goDetail(item.sid)">
                <img class="school-logo" :src="item.logo" />
                <div class="school-info">
                    <div class="school-name">{{item.name}}</div>
                    <div class="flex">
                        <div class="info-item">{{item.arr.one}}</div>
                        <div class="info-item">{{item.arr.two}}</div>
                    </div>
                    <div class="flex">
                         <div class="info-item">{{item.arr.threee}}</div>
                        <div class="info-item">{{item.arr.four}}</div>
                    </div>
                </div>
                <div class="school-hot">人气:{{item.mood}}</div>
            </div>
        </div>
        
    </div>
    <div v-else class="_noPost">
       <image src="https://new.schoolpi.net/attach/small_program/index/no-data.png" class="no-data"></image>
    </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data(){
        return{
             schoolLists:[]
        }
    },
    created() {},
    methods: {
        // 点击进入学校详情
        goDetail(e){
            this.$router.push({
               path:"/fenlei/HostDetail",
               query:{
                   sid:e
               }
           })
        },
       //获取相关专业学校列表
        fetchSchoolList(cid) {
            httpPost("/classifie/career_school", {
               province: this.$store.state.areaInfo.pid,
               cid:cid
            }).then(res => {
               
                if (res.code === 1) {
                   this.schoolLists=res.list
                }else{
                    this.$toast(res.msg)
                }
            });
        }
    },
    mounted() {
        
        this. fetchSchoolList(this.$route.query.cid);
    },
    components: {
        PublicHead
    }
}
</script>

<style scoped>
    .page{
    background: #f2f2f2;
}
.school-list{
    margin-top: 46px;
}
.search{
    background: #22d8d9;
    padding: 0.625rem 0;
    position: relative
}
.search-content{
    height: 1.875rem;
    margin: 0 0.9375rem;
    background: #fff;
	border-radius: 0.9375rem;
    padding-left: 2.0625rem;
	font-size: 0.8125rem;
}
.search-icon{
    width: 0.9375rem;
    height: 0.9375rem;
    position: absolute;
    left: 1.5625rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
    /* border: 2rpx solid red; */
}
.school-item{
    display: flex;
    margin-top: 0.625rem;
    background: #fff;
    position: relative;
}
.school-logo{
    width: 3.75rem;
    height: 3.75rem;
    margin: 0.625rem 0.9375rem;
    border-radius: 1.875rem;
}
.school-name{
    font-size: 0.9375rem;
    margin: 0.625rem 0 0.1875rem 0;
    font-weight: bold;
}
.flex{
    display: flex;
}
.info-item{
    width: 8.4375rem;
    font-size: 0.75rem;
    color: #a9a9a9;
    margin-bottom:0.3125rem;
}
.school-hot{
    position: absolute;
    top: 0.8125rem;
    right: 0.9375rem;
    color: #ffbb29;
    font-size: 0.75rem;
}
._noPost{
    text-align: center;
   position: relative;
}
.no-data{
    width: 6.25rem;
    height: 6.25rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}

</style>
